<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-map-action-popup">
		<div class="app-map-action-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span i18n="@@map.action.popup.concernedElement">
					concerned Element
				</span>
				<span class="app-map-action-popup__element-label">
					{{ vo.element }}
				</span>
			</ng-container>
			<ng-container *ngIf="vo.isMultipleElement">
				<span i18n="@@map.action.popup.concernedElements">
					concerned Elements
				</span>
				<div class="app-map-action-popup__element-label">
					{{ vo.mapId.length }}
					<span i18n="@@map.action.popup.maps">Cartes</span>
				</div>
			</ng-container>
		</div>
		<ng-container [ngSwitch]="vo.action">
			<div
				*ngSwitchCase="MapAction.Delete"
				class="app-map-action-popup__delete">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-map-action-popup__description"
					i18n="@@map.action.popup.delete.multiple.description">
					deletion request
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-map-action-popup__description"
					i18n="@@map.action.popup.delete.description">
					deletion request
				</span>

				<div class="app-map-action-popup__delete-info">
					<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-map-action-popup__message"
						i18n="@@map.action.popup.delete.multiple.info">
						deletion info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-map-action-popup__message"
						i18n="@@map.action.popup.delete.info">
						deletion info
					</span>
				</div>
				<div class="app-map-action-popup__checkbox">
					<mat-checkbox
						id="{{ cmpId }}-confirm-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
							<span i18n="@@map.action.popup.delete.confirm">confirm delete</span>
					</mat-checkbox>
				</div>
			</div>
		</ng-container>
	</div>

	<div modal-footer class="app-map-action-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="MapAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-map-action-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span i18n="@@map.action.popup.delete.btn">delete</span>
			</button>
		</ng-container>
	</div>
</app-modal>
